<template>
  <v-app>
    <v-container class="appclick">
      <Header>
        <font-awesome-icon :icon="['fas', 'diagnoses']" />
        <font-awesome-icon :icon="['fas', 'cogs']" />
        <font-awesome-icon :icon="['fas', 'compress']" />
        <span class="title">Directions</span>
      </Header>
      <v-row>
        <v-col class="col-7"> <div id="map" class="map"></div> </v-col>
        <v-col class="col-5">
          <v-form>
            <table>
              <tr>
                <td colspan="2">To store zones, a streetname is obliged.</td>
                <th colspan="2">
                  <img src="../assets/images/direction_left.jpg" />
                </th>
                <th colspan="2">
                  <img src="../assets/images/direction_straight.jpg" />
                </th>
                <th colspan="2">
                  <img src="../assets/images/direction_right.jpg" />
                </th>
                <th colspan="2">
                  <img src="../assets/images/direction_uturn.jpg" />
                </th>
              </tr>
              <tr>
                <th class="thcel">Nr</th>
                <th class="thname">Streetname</th>
                <th class="thcel">Org</th>
                <th class="thcel">Dest</th>
                <th class="thcel">Org</th>
                <th class="thcel">Dest</th>
                <th class="thcel">Org</th>
                <th class="thcel">Dest</th>
                <th class="thcel">Org</th>
                <th class="thcel">Dest {{ nzones }}</th>
              </tr>
              <tr v-for="row in directions" :key="row.name">
                <td class="tdname">{{ row.zone_id }}</td>
                <td class="tdname">
                  <input v-model="row.legname" type="text" />
                </td>
                <td>
                  <span v-for="(n, opt) in zone_id" :key="opt">
                    <input v-model="row.l_org" type="radio" :value="opt" />{{
                      opt
                    }}<br />
                  </span>
                </td>
                <td>
                  <span v-for="(n, opt) in zone_id" :key="opt">
                    <input v-model="row.l_dest" type="radio" :value="opt" />{{
                      opt
                    }}<br />
                  </span>
                </td>

                <td>
                  <span v-for="(n, opt) in zone_id" :key="opt">
                    <input v-model="row.m_org" type="radio" :value="opt" />{{
                      opt
                    }}<br />
                  </span>
                </td>
                <td>
                  <span v-for="(n, opt) in zone_id" :key="opt">
                    <input v-model="row.m_dest" type="radio" :value="opt" />{{
                      opt
                    }}<br />
                  </span>
                </td>

                <td>
                  <span v-for="(n, opt) in zone_id" :key="opt">
                    <input v-model="row.r_org" type="radio" :value="opt" />{{
                      opt
                    }}<br />
                  </span>
                </td>
                <td>
                  <span v-for="(n, opt) in zone_id" :key="opt">
                    <input v-model="row.r_dest" type="radio" :value="opt" />{{
                      opt
                    }}<br />
                  </span>
                </td>

                <td>
                  <span v-for="(n, opt) in zone_id" :key="opt">
                    <input v-model="row.u_org" type="radio" :value="opt" />{{
                      opt
                    }}<br />
                  </span>
                </td>
                <td>
                  <span v-for="(n, opt) in zone_id" :key="opt">
                    <input v-model="row.u_dest" type="radio" :value="opt" />{{
                      opt
                    }}<br />
                  </span>
                </td>
              </tr>
            </table>

            <v-btn @click="submitdestination">Save</v-btn>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import Map from "ol/Map";
import View from "ol/View";
import "ol/ol.css";
import { Vector as VectorSource } from "ol/source";
import Static from "ol/source/ImageStatic";
import { getCenter } from "ol/extent";
import { Vector as VectorLayer } from "ol/layer";
import ImageLayer from "ol/layer/Image";
import GeoJSON from "ol/format/GeoJSON";
import Projection from "ol/proj/Projection";
import { Fill, Stroke, Style, Text } from "ol/style";
import ProjectService from "@/services/ProjectService.js";
import Header from "@/components/Header.vue";
var vectorsource;
var vectorlayer;
var extent = [0, 0, 720, 480];
var projection = new Projection({
  code: "static-image",
  units: "pixels",
  extent: extent
});

export default {
  data: function() {
    return {
      vectorlayer: null,
      verctorsource: null,
      map: null,
      directions: {},
      zones: {},
      foto: "",
      ncols: 6,
      nzones: {},
      zone_id: {},
      i: 1
    };
  },
  components: {
    Header
  },
  mounted() {
    this.GetDirections();
  },
  methods: {
    GetDirections() {
      ProjectService.apiGet({
        nid: this.$session.get("PROJID"),
        type: "settings_directions"
      })
        .then(response => {
          //console.log(response.data);
          this.zone_id = response.data.zone_ids;
          this.directions = response.data.directions;
          this.zones = response.data.zones;
          this.foto = response.data.foto;
          this.nzones = response.data.nzones;
          vectorsource = new VectorSource({
            features: new GeoJSON().readFeatures(this.zones)
          });
          this.ShowZones();
        })
        .catch(error => {
          console.log("Fout " + error.response);
        });
    },
    ShowZones() {
      vectorsource = new VectorSource({
        features: new GeoJSON().readFeatures(this.zones)
      });
      var image = new ImageLayer({
        source: new Static({
          url: this.foto,
          projection: projection,
          imageExtent: extent
        })
      });
      vectorlayer = new VectorLayer({
        source: vectorsource,
        style: styleFunction
      });
      var map = new Map({
        layers: [image, vectorlayer],
        target: "map",
        controls: [],
        interactions: [],
        view: new View({
          projection: projection,
          center: getCenter(extent),
          zoom: 1.14,
          maxzoom: 1.14,
          attribution: false
        })
      });
      function styleFunction(feature) {
        var att = feature.getProperties();
        return [
          new Style({
            fill: new Fill({
              color: "rgba(255, 0, 0, 0.2)"
            }),
            stroke: new Stroke({
              color: "#0000ff",
              width: 2
            }),
            text: new Text({
              font: "40px Calibri,sans-serif",
              fill: new Fill({ color: "#000" }),
              text: "" + att.id
            })
          })
        ];
      }
      map.on("click", function() {});
    },
    submitdestination() {
      //console.log(e);
      //e.preventDefault();
      //let currentObj = this;
      let vars = this.directions;
      console.log(vars);
      ProjectService.apiPost({
        nid: this.$session.get("PROJID"),
        type: "settings_directions_update",
        vars
      })
        .then(function(response) {
          //currentObj.output = response.data;
          console.log(response);
        })
        .catch(e => {
          console.log(e);
          //this.errors.push(e);
        });
    }
  }
};
</script>
<style scoped>
.map {
  height: 420px;
  padding: 0px;
  width: 630px;
}

.button,
button {
  align-items: center;
  justify-content: center;
  width: 8em;
  height: 2em;
  margin: 0.5em;
  border-radius: 5px;
  background: linear-gradient(to right, #16c0b0, #84cf6a);
  font-size: 1em;
  color: white;
  border: none;
  outline: none;
}

img {
  height: 30px;
}

table {
  font-size: 0.9em;
}

td {
  border-style: solid;
  border-width: thin;
}

th.thcel {
  width: 40px;
}

td.thcel {
  text-align: center;
}

th {
  border-style: solid;
  border-width: thin;
}
</style>
